import { Injectable } from '@angular/core';
import { GoApplicationRequestFormModel } from '../../../shared/models/go-application-request-form-model';
import { GoApplicationRequest } from '../../../shared/models/go-application-request';
import { GoCoordinatesType } from '../../models/go-coordinates-type';
import { GoAntennaHeightUnitType } from '../../models/go-antenna-height-unit-type';
import {
    tryToEnum,
    tryToEnumArray,
} from '../../../../../../core/functions/enum-helper';
import { GoEmissionDesignatorPowerType } from '../../models/go-emission-designator-power-type';
import { GoEmissionDesignatorInformationType } from '../../models/go-emission-designator-information-type';
import { GoDataDirectionType } from '../../models/go-data-direction-type';
import { GoStationClassType } from '../../models/go-station-class-type';
import { GoFrequencyType } from '../../models/go-frequency-type';
import { GoLocationType } from '../../models/go-location-type';

@Injectable({
    providedIn: 'root',
})
export class GoParametersMappingService {
    /**
     * Maps a {@link GoApplicationRequest} DTO into a Go application parameters form model.
     *
     * @param request The Go application request to map from.
     * @returns A partial {@link GoApplicationRequestFormModel} containing the mapped parameters.
     */
    mapRequestToGoApplicationFormModel(
        request: GoApplicationRequest,
    ): Partial<GoApplicationRequestFormModel> {
        const frequencyType = tryToEnum(GoFrequencyType, request.frequencyType);
        const locationType = tryToEnum(GoLocationType, request.locationType);
        const stationClassType = tryToEnum(
            GoStationClassType,
            request.stationClassType,
        );
        const dataDirectionType = tryToEnum(
            GoDataDirectionType,
            request.dataDirectionType,
        );

        const antennaHeightUnitType = tryToEnum(
            GoAntennaHeightUnitType,
            request.antennaHeightUnitType,
        );

        const emissionDesignatorInformationType = tryToEnum(
            GoEmissionDesignatorInformationType,
            request.emissionDesignatorInformationType,
        );

        const emissionDesignatorPowerType = tryToEnumArray(
            GoEmissionDesignatorPowerType,
            request.emissionDesignatorPowerType,
        );

        return {
            applicationPurpose: request.applicationPurpose,
            frequencyType,
            locationType,
            stationClassType,
            dataDirectionType,
            numberOfFrequencies: request.numberOfFrequencies,
            coordinatesType: GoCoordinatesType.LatitudeLongitude,
            latitude: request.latitude?.toString(),
            longitude: request.longitude?.toString(),
            antennaHeightUnitType,
            heightToTip:
                request.heightToTip != null
                    ? String(request.heightToTip)
                    : null,
            fixedErp:
                request.fixedErp != null ? String(request.fixedErp) : null,
            mobileErp:
                request.mobileErp != null ? String(request.mobileErp) : null,
            emissionDesignatorInformationType,
            emissionDesignatorPowerType,
        };
    }
}
